import { generarMiniaturaRandom } from '../helpers/generarMiniaturaRandom';

const palabrasTresLetras = [
  "sol", "mar", "pan", "pez", "voz", "sal", "rey", "luz", "pie", "fin", "ala", "ojo", "uva", "hoy", "ave", "eco", "ola", "uno", "dos"
];

const crucigramasData = [
  // id 1 title: "La pequeña aldea"
  {
    id: 1,
    title: "La pequeña aldea",
    description: "Obra Relacionada: La pequeña aldea",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "LAPEQUEÑAALDEA",
          row: 0,
          col: 9,
        },
      },
      across: {
        1: {
          clue: "Paseo arbolado junto al río por la actual calle L. N. Alem, construido por el Virrey Vértiz",
          answer: "ALAMEDA",
          row: 0,
          col: 8,
        },
        2: {
          clue: "Refresco preparado con agua, azúcar y vinagre",
          answer: "VINAGRADA",
          row: 1,
          col: 3,
        },
        3: {
          clue: "Peineta de casi 1,50 m, fabricada solo en el Río de la Plata por Manuel Masculino en tiempos de Rosas",
          answer: "PEINETON",
          row: 2,
          col: 9,
        },
        4: {
          clue: "Edificio ubicado en el centro de la Plaza de Mayo entre 1803 y 1880. Bajo sus arcos se vendían comidas, telas, ropas y monturas. Era como un shopping",
          answer: "RECOVA",
          row: 3,
          col: 8,
        },
        5: {
          clue: "Palabra quichua que nombraba al sistema de correo que consistía en enviar el mensaje con un jinete a todo galope de posta en posta",
          answer: "CHASQUI",
          row: 4,
          col: 5,
        },
        6: {
          clue: "Reunión social en la que se leía, bailaba la gavota o el cielito, se tocaba guitarra o piano. Se comían huevitos de perdiz, mulitas guisadas, dulce de toronja y licor de mandarina",
          answer: "TERTULIA",
          row: 5,
          col: 5,
        },
        7: {
          clue: "Vehículo tirado por dos o tres parejas de bueyes que transportaba mercaderías y pasajeros, constituido por una caja de madera cubierta con pajas y cueros",
          answer: "CARRETA",
          row: 6,
          col: 5,
        },
        8: {
          clue: 'Especie de armazón de mimbre o crines de caballo trenzadas, también llamado "crinolina, utilizado para abultar la falda del vestido de las mujeres en tiempos de Rosas',
          answer: "MIRIÑAQUE",
          row: 7,
          col: 5,
        },
        9: {
          clue: "Especie de cisterna o pozo subterráneo recubierto de ladrillos que se llenaba con el agua recogida durante la lluvia",
          answer: "ALJIBE",
          row: 8,
          col: 9,
        },
        10: {
          clue: "Elemento con el cual los vecinos de Buenos Aires solían tapar los pozos formados en las calles por el constante paso de carretas y caballos",
          answer: "BASURA",
          row: 9,
          col: 8,
        },
        11: {
          clue: "Edificio en el que residían las autoridades municipales y judiciales. Tenía originariamente 10 pares de arcos",
          answer: "CABILDO",
          row: 10,
          col: 5,
        },
        12: {
          clue: "Sistema social basado en el trabajo sin salario de las personas. Abolido parcialmente por la Asamblea de 1813",
          answer: "ESCLAVITUD",
          row: 11,
          col: 0,
        },
        13: {
          clue: "Edificio amurallado con almenas de vigilancia, cañones y guardia militar donde residían las autoridades gubernamentales",
          answer: "FUERTE",
          row: 12,
          col: 4,
        },
        14: {
          clue: "Antiguamente: ladrones. En Buenos Aires salían a robar por la noche con una caña de pescar",
          answer: "CACOS",
          row: 13,
          col: 8,
        },
      },
    },
  },
  // id 2 title: "Cabildo Abierto"  
  {
    id: 2,
    title: "Cabildo Abierto",
    description: "Obra Relacionada: Cabildo Abierto",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del edificio histórico en el centro de la Plaza de Mayo.",
          answer: "CABILDOABIERTO",
          row: 1,
          col: 6,
        },
      },
      across: {
        1: {
          clue: "Acción que Baltasar Hidalgo de Cisneros realiza dos veces el día 24 de mayo de 1810. Primero como virrey y luego como presidente de la junta.",
          answer: "RENUNCIAR",
          row: 1,
          col: 1,
        },
        2: {
          clue: "Nombre del rey Borbón, hijo de Carlos IV, que fuera enviado a prisión tras la ocupación napoleónica a España.",
          answer: "FERNANDO",
          row: 2,
          col: 2,
        },
        3: {
          clue: "(Marqués de...) Nombre del virrey que escapa a Córdoba ante la inminente invasión inglesa.",
          answer: "SOBREMONTE",
          row: 3,
          col: 4,
        },
        4: {
          clue: "Autoridad que los criollos le otorgan a Santiago de Liniers después del triunfo sobre los ingleses.",
          answer: "VIRREY",
          row: 4,
          col: 5,
        },
        5: {
          clue: "Grupo contrario a los criollos a quienes estaban destinadas la mayoría de las invitaciones cursadas por el virrey Cisneros para el Cabildo Abierto del 22 de mayo.",
          answer: "ESPAÑOLES",
          row: 5,
          col: 0,
        },
        6: {
          clue: "Lugares por los cuales debían pasar las mercaderías provenientes de España para ser controladas y pagar el impuesto correspondiente.",
          answer: "ADUANAS",
          row: 6,
          col: 5,
        },
        7: {
          clue: "Nombre que recibe el tipo de economía que obliga a comerciar exclusivamente con una única ciudad.",
          answer: "MONOPOLIO",
          row: 7,
          col: 5,
        },
        8: {
          clue: "Tipo de gobierno que eligieron los criollos para reemplazar la autoridad del virrey y del rey durante los sucesos de mayo de 1810.",
          answer: "JUNTA",
          row: 8,
          col: 2,
        },
        9: {
          clue: "Apellido del emperador francés que ocupara los territorios españoles en 1808, desplazando al rey y poniendo en su lugar a su hermano, José.",
          answer: "BONAPARTE",
          row: 9,
          col: 6,
        },
        10: {
          clue: "Objeto que originó el puerto de Buenos Aires: la fragata inglesa Milestone en marzo de 1810 y difundió la noticia de que el rey estaba preso.",
          answer: "PERIODICOS",
          row: 10,
          col: 0,
        },
        11: {
          clue: "Grupo armado que el pueblo de Buenos Aires formó para defenderse durante las invasiones de los ingleses y que luego no quiso desarticular.",
          answer: "EJERCITO",
          row: 11,
          col: 1,
        },
        12: {
          clue: "Nombre que reciben los descendientes de españoles nacidos en América.",
          answer: "CRIOLLOS",
          row: 12,
          col: 2,
        },
        13: {
          clue: "Lo que estuvieron contando las autoridades del Cabildo durante el día 23 de mayo de 1810 para saber cuál opinión triunfaba tras las discusiones realizadas el día anterior durante una asamblea conocida como 'Cabildo Abierto'.",
          answer: "VOTOS",
          row: 13,
          col: 4,
        },
        14: {
          clue: "País de origen del regimiento 71 de Highlanders, el cual nunca había sido derrotado por lo que era considerado el más poderoso de la época.",
          answer: "ESCOCIA",
          row: 14,
          col: 3,
        },
      },
    },
  },
  // id 3 title: "Cristóbal Colón"
  {
    id: 3,
    title: "Cristóbal Colón",
    description: "Obra Relacionada: 00 Sin Obra",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre de pila del navegante genovés que realizó el viaje transatlántico en 1492 y descubrió América para Europa.",
          answer: "CRISTOBAL",
          row: 0,
          col: 4,
        },
      },
      across: {
        1: {
          clue: "Tipo de embarcación diseñada por Enrique el Navegante, rey de Portugal, sobre la base del galeón. Destinada para carga, equipada con dos velas cuadradas y una latina (triangular). Al llegar a las islas Canarias C. Colón mandó cambiarle todas las velas latinas por cuadradas para lograr mayor velocidad.",
          answer: "CARABELA",
          row: 0,
          col: 4,
        },
        2: {
          clue: "Monedas de la época. Para la expedición de Colón se necesitaron alrededor de dos millones de ese dinero, que no fue aportado por los Reyes Católicos sino por banqueros italianos y por el pueblo del Puerto de Palos de Noguer.",
          answer: "MARAVEDIES",
          row: 1,
          col: 2,
        },
        3: {
          clue: "(Rodrigo de....) Apellido del marinero que avistó tierra el 12 de octubre de 1492 a las 2 de la mañana. Dicen que se quedó festejando toda la noche porque creía haber ganado la recompensa de diez mil maravedíes asignada por la reina Isabel para el primero que avistara tierra.",
          answer: "TRIANA",
          row: 2,
          col: 2,
        },
        4: {
          clue: "Nombre genérico de los productos procedentes de las Indias que en Europa se usaban para perfumar, saborizar y conservar alimentos. Eran un rasgo de distinción y poder. Entre los más comunes figuran: pimienta, jengibre, clavo de olor, canela, nuez moscada.",
          answer: "ESPECIAS",
          row: 3,
          col: 3,
        },
        5: {
          clue: "Recipientes en los cuales se almacenaba, especialmente, vino y agua para el viaje. La Santa María podía albergar 240 de estos recipientes. Con el tiempo el número de recipientes que cada nave podía albergar se transformó en la unidad que mide la capacidad de una nave (equivale a 1.000 Kg.)",
          answer: "TONEL",
          row: 4,
          col: 4,
        },
        6: {
          clue: "Apellido del navegante genovés que comandó la expedición que llegó a América en 1492.",
          answer: "COLON",
          row: 5,
          col: 1,
        },
        8: {
            clue: "Espacio interior del barco debajo de la cubierta, destinado a almacenar las mercancías y las provisiones.",
            answer: "BODEGA",
            row: 6,
            col: 4,
        },
        7: {
          clue: "Herramienta de medición que consistía en la sexta parte de un círculo divido en grados y con una mira que se apuntaba a la estrella polar. Con esta herramienta se calcula la posición de barco cuando se aleja de la costa.",
          answer: "SEXTANTE",
          row: 7,
          col: 0,
        },
        9: {
          clue: "Utensilios para inmovilizar la nave. Pesan entre 400 a 600 Kg. Se necesitaba toda la tripulación para moverlos y se tardaba casi 1 hora. Si había peligro de ataque pirata o de tormentas, los gruesos cabos que los sujetaban eran cortados con un hacha.",
          answer: "ANCLAS",
          row: 8,
          col: 1,
        },
      },
    },
  },
  // id 4 title: "Alegría de la libertad"
  {
    id: 4,
    title: "Alegría de la libertad",
    description: "Obra Relacionada: Alegría de la Libertad",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
        down: {
          1: {
            clue: "Nombre del crucigrama",
            answer: "ALEGRIALIBERTAD",
            row: 0,
            col: 7
          }
        },
        across: {
          1: {
            clue: "Nombre de la junta en la que por fin pudieron reunirse los representantes de las provincias 3 años después del 25 de mayo.",
            answer: "ASAMBLEA",
            row: 0,
            col: 5
          },
          2: {
            clue: `Apellido del diputado que en la obra recibe el apodo de "Pepitito"`,
            answer: "LOPEZYPLANES",
            row: 1,
            col: 0
          },
          3: {
            clue: `Una de las resoluciones de la Asamblea. Su característica es la de tener grabadas las palabras "En unión y libertad"`,
            answer: "MONEDA",
            row: 2,
            col: 4
          },
          4: {
            clue: `Apellido del diputado que en la obra se lo nombra como "Bernardito"`,
            answer: "MONTEAGUDO",
            row: 3,
            col: 1
          },
          5: {
            clue: "Año en el que se realizó la famosa asamblea",
            answer: "TRECE",
            row: 4,
            col: 6
          },
          6: {
            clue: "Uno de los símbolos patrios surgidos de la Asamblea",
            answer: "HIMNO",
            row: 5,
            col: 6
          },
          7: {
            clue: "Nombre que reciben los enviados por las monarquías europeas (Rusia, Portugal e Inglaterra, principalmente) para evitar la declaración de Independencia",
            answer: "ESPIAS",
            row: 6,
            col: 3
          },
          8: {
            clue: "Actual provincia argentina que en 1816 constituía la frontera que no debía ser traspasada por las tropas realistas.",
            answer: "SALTA",
            row: 7,
            col: 5
          },
          9: {
            clue: "Palabra quichua con la que designaba a los mensajeros que llevaron el Acta de la Independencia por todo el país",
            answer: "CHASQUIS",
            row: 8,
            col: 1
          },
          10: {
            clue: "Nombre del general y patriota argentino encargado del Ejército de Norte",
            answer: "BELGRANO",
            row: 9,
            col: 7
          },
          11: {
            clue: "Nombre del general y patriota argentino encargado de frenar con sus gauchos la invasión realista por el Norte",
            answer: "GÜEMES",
            row: 10,
            col: 5
          },
          12: {
            clue: "Uno de los idiomas aborígenes en el cual fue escrita el Acta de la Independencia",
            answer: "AIMARA",
            row: 11,
            col: 3
          },
          13: {
            clue: "Nombre de la fragata que en 1817 fue encargada de llevar el Acta de Independencia por todo el mundo",
            answer: "ARGENTINA",
            row: 12,
            col: 2
          },
          14: {
            clue: "Nombre de la primera nación que reconoció la Independencia argentina",
            answer: "HAWAII",
            row: 13,
            col: 4
          },
          15: {
            clue: "Apellido del marino que llevó adelante el viaje alrededor del mundo para lograr el reconocimiento de la Independencia",
            answer: "BOUCHARD",
            row: 14,
            col: 0
          }
        }
      }
  },
  // id 5 title: "Originariamente Argentina"
  {
    id: 5,
    title: "Originariamente Argentina",
    description: "Obra Relacionada: Originariamente Argentina",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "ORIGINARIOS",
          row: 0,
          col: 4
        }
      },
      across: {
        1: {
          clue: "Nombre de las sandalias utilizadas por los diaguitas",
          answer: "OJOTAS",
          row: 0,
          col: 2
        },
        2: {
          clue: "¿Qué utilizaban los guaraníes como si fuera una moneda?",
          answer: "YERBA",
          row: 1,
          col: 2
        },
        3: {
          clue: "Nombre en guaraní que recibe el recipiente del mate",
          answer: "CAIGUA",
          row: 2,
          col: 2
        },
        4: {
          clue: "¿Con qué melodía se llaman entre los cerros los chicos y chicas que descienden de los diaguitas, cuando van a la escuela?",
          answer: "BAGUALAS",
          row: 3,
          col: 2
        },
        5: {
          clue: "¿Qué planta alta sembraban los guaraníes primero para darle sombra a las batatas y las mandiocas, y para que se enrienden los porotos?",
          answer: "MAIZ",
          row: 4,
          col: 2
        },
        6: {
          clue: "¿Qué elemento muy utilizado por los yámanas era llamado por ellos 'Anán'?",
          answer: "CANOA",
          row: 5,
          col: 2
        },
        7: {
          clue: "¿Cuál era el animal que los querandíes preferían cazar?",
          answer: "GUANACO",
          row: 6,
          col: 2
        },
        8: {
          clue: "¿Quién baja del cielo, en la leyenda Toba, y le regala al chico triste un violín de una cuerda llamado Nuybiqué?",
          answer: "ESTRELLA",
          row: 7,
          col: 1
        },
        9: {
          clue: "Entre lo diaguitas el ñandú representa la Tierra; el sapo, el agua; la serpiente, el fuego; y el cóndor ¿Qué representa?",
          answer: "AIRE",
          row: 8,
          col: 3
        },
        10: {
          clue: "Insecto que los querandíes gustaban de comer cocinado y machacado como si fuera una mayonesa",
          answer: "LANGOSTA",
          row: 9,
          col: 0
        },
        11: {
          clue: "Pueblo del sur que solía hacer fogatas para avisarle a sus vecinos, los Yámanas, que había comida para todos porque había encallado una ballena en la playa",
          answer: "ONAS",
          row: 10,
          col: 1
        }
      }
    }
  },
  // id 6 title: "Cuentos con granaderos"
  {
    id: 6,
    title: "Cuentos con granaderos",
    description: "Obra Relacionada: Cuentos con granaderos",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Palabra central que forma el nombre de la obra",
          answer: "CUENTOSGRANADEROS",
          row: 0,
          col: 6,
        }
      },
      across: {
        1: {
          clue: "Actividad que le gustaba hacer a San Martín cuando era anciano",
          answer: "CARPINTERIA",
          row: 0,
          col: 6,
        },
        2: {
          clue: "¿De qué era la casa que le hizo a Mercedes y Josefa?",
          answer: "MUÑECAS",
          row: 1,
          col: 5,
        },
        3: {
          clue: "¿Cómo se le decía al vendedor ambulante que llevaba colgada del cuello una cajita denominada 'bandola'?",
          answer: "BANDOLERO",
          row: 2,
          col: 0,
        },
        4: {
          clue: "¿Para qué fiesta fue la cena en la que diseñaron la bandera del Ejército de Los Andes?",
          answer: "NAVIDAD",
          row: 3,
          col: 6,
        },
        5: {
          clue: "¿Qué eran Josefa y María Mercedes de San Martín?",
          answer: "NIETAS",
          row: 4,
          col: 3,
        },
        6: {
          clue: "¿Qué tenían las fuentes que le llevaban los vecinos a Remeditos?",
          answer: "COMIDA",
          row: 5,
          col: 5,
        },
        7: {
          clue: "¿Qué le bordaron a la bandera para destacar la idea de la libertad?",
          answer: "ESCUDO",
          row: 6,
          col: 5,
        },
        8: {
          clue: "¿Cómo eran los puentes que Fray Luis diseño para cruzar los precipicios?",
          answer: "COLGANTES",
          row: 7,
          col: 3,
        },
        9: {
          clue: "¿Cuántas fueron las cordilleras que tuvo que cruzar San Martín?",
          answer: "CUATRO",
          row: 8,
          col: 2,
        },
        10: {
          clue: "Nombre del sacerdote que organizó toda la artillería y lo necesario para el viaje",
          answer: "FRAYLUIS",
          row: 9,
          col: 4,
        },
        11: {
          clue: "Nombre 'teatral' que se le da al simulacro de cruce que hicieron los granaderos voluntarios para verificar los problemas del camino",
          answer: "ENSAYO",
          row: 10,
          col: 5,
        },
        12: {
          clue: "¿Qué comían para combatir el mal de altura?",
          answer: "CEBOLLAS",
          row: 11,
          col: 0,
        },
        13: {
          clue: "Elemento que diseñaron durante la noche de Navidad en casa de San Martín en Mendoza",
          answer: "BANDERA",
          row: 12,
          col: 3,
        },
        14: {
          clue: "¿De qué año es la Asamblea que instauró el escudo que se bordó en la bandera",
          answer: "TRECE",
          row: 13,
          col: 4,
        },
        15: {
          clue: "País en el cual San Martín vivó con su hija y sus nietas",
          answer: "FRANCIA",
          row: 14,
          col: 5,
        },
        16: {
          clue: "Elemento que contenía agua y que Fray Luis ordenó dejar en los caminos de la cordillera",
          answer: "BOTELLAS",
          row: 15,
          col: 5,
        },
        17: {
          clue: "Color de la tela que le faltaba conseguir a Remedios y la obtiene del bandolero",
          answer: "CELESTE",
          row: 16,
          col: 2,
        }
      }
    }
  },
  // id 7 title: "Nueve cajones mágicos"
  {
    id: 7,
    title: "Nueve cajones mágicos",
    description: "Obra Relacionada: Nueve cajones mágicos en julio",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: 'Nombre del crucigrama',
          answer: 'NUEVEDEJULIO',
          row: 0,
          col: 11,
        },
      },
      across: {
        1: {
          clue: 'Estatuto redactado por los diputados españoles para controlar al rey y garantizar al pueblo sus derechos y libertades; y que dicho monarca fingió obedecer para ser restituido',
          answer: 'CONSTITUCION',
          row: 0,
          col: 0,
        },
        2: {
          clue: 'Nombre del cacique araucano que en el siglo XVI comandara un levantamiento contra los españoles',
          answer: 'LAUTARO',
          row: 1,
          col: 9,
        },
        3: {
          clue: 'Nombre del monarca español, apodado el deseado que envía un regimiento de 10.000 soldados para recuperar sus colonias',
          answer: 'FERNANDO',
          row: 2,
          col: 10,
        },
        4: {
          clue: 'Apellido de uno de los fundadores de la Logia Lautaro, primo de San Martín y ferviente opositor a declarar la Independencia en 1813',
          answer: 'ALVEAR',
          row: 3,
          col: 9,
        },
        5: {
          clue: 'Apellido del militar salteño encargado de frenar el avance realista en las fronteras de Salta y Jujuy',
          answer: 'GÜEMES',
          row: 4,
          col: 9,
        },
        6: {
          clue: 'Uno de los símbolos nacionales creados por la Asamblea del año 1813',
          answer: 'MONEDA',
          row: 5,
          col: 7,
        },
        7: {
          clue: 'Nombre del congresal y poeta argentino, autor de la letra que resultara elegida como Himno Nacional en la Asamblea del año 1813',
          answer: 'VICENTE',
          row: 6,
          col: 8,
        },
        8: {
          clue: 'Nombre de la Teniente Coronel de Milicias que combate junto a Güemes en la frontera del Norte',
          answer: 'JUANA',
          row: 7,
          col: 11,
        },
        9: {
          clue: 'Uno de los símbolos nacionales creados por la Asamblea del año 1813, utilizado al principio como sello',
          answer: 'ESCUDO',
          row: 8,
          col: 8,
        },
        10: {
          clue: 'Organización secreta que comandó los destinos políticos del país hasta 1816',
          answer: 'LOGIA',
          row: 9,
          col: 11,
        },
        11: {
          clue: 'Apellido del oficial de Güemes que con solo 30 soldados obligó a un batallón de 300 realistas a huir dejando sus pertrechos en un desfiladero entre montañas',
          answer: 'LAMADRID',
          row: 10,
          col: 5,
        },
        12: {
          clue: 'Nombre del fraile que fuera congresal en la Asamblea del Año 1813, cuya canción patriótica compitiera en la elección del Himno con la de Vicente López',
          answer: 'CAYETANO',
          row: 11,
          col: 4,
        },
      },
    },
  },
  // id 8 title: "Obligada estaba la Vuelta"
  {
    id: 8,
    title: "Obligada estaba la Vuelta",
    description: "Obra Relacionada: Obligada estaba la vuelta",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: 'Nombre del crucigrama',
          answer: 'OBLIGADA',
          row: 0,
          col: 8,
        },
      },
      across: {
        1: {
          clue: 'Color de la divisa que ordenaba Rosas que todos usaran',
          answer: 'ROJO',
          row: 0,
          col: 7,
        },
        2: {
          clue: 'Durante el gobierno de Rosas hubo un ¿. . . . . . .? en el Puerto de Buenos Aires',
          answer: 'BLOQUEO',
          row: 1,
          col: 8,
        },
        3: {
          clue: '¿Cómo se llamaba la hija del gobernador Juan Manuel de Rosas?',
          answer: 'MANUELITA',
          row: 2,
          col: 3,
        },
        4: {
          clue: '¿Cuál era el apellido del tío de Manuelita que se llamaba Lucio?',
          answer: 'MANSILLA',
          row: 3,
          col: 4,
        },
        5: {
          clue: 'El bloqueo al Puerto de Buenos Aires fue realizado por barcos franceses e ¿. . . . . . . .?',
          answer: 'INGLESES',
          row: 4,
          col: 6,
        },
        6: {
          clue: 'Nombre de la Revolución europea cuyo resultado fue un exceso de mercadería para vender',
          answer: 'INDUSTRIAL',
          row: 5,
          col: 0,
        },
        7: {
          clue: '¿Qué fue lo que Mansilla terminó poniendo en el río para evitar que pasaran los barcos invasores?',
          answer: 'CADENAS',
          row: 6,
          col: 6,
        },
        8: {
          clue: '¿Cómo se llamaban los puestos de defensa con cañones que Mansilla colocó sobre las barrancas?',
          answer: 'BATERIAS',
          row: 7,
          col: 2,
        },
      },
    },
  },
  // id 9 title: "Viaje adentro de la Tierra"
  {
    id: 9,
    title: "Viaje adentro de la Tierra",
    description: "Obra Relacionada: Viaje adentro de la Tierra",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: 'Nombre del crucigrama',
          answer: 'VIAJETIERRA',
          row: 0,
          col: 8,
        },
      },
      across: {
        1: {
          clue: '¿Cuál es la principal actividad física de un arquéologo, además de investigar?',
          answer: 'EXCAVAR',
          row: 0,
          col: 4,
        },
        2: {
          clue: '¿Qué objeto del director pierden los Gutiérrez?',
          answer: 'ANILLO',
          row: 1,
          col: 6,
        },
        3: {
          clue: '¿A qué se parece la descripción de las capas geológicas?',
          answer: 'TORTA',
          row: 2,
          col: 4,
        },
        4: {
          clue: '¿De qué felino se oían los rugidos en la pampa en tiempos de los hets?',
          answer: 'JAGUAR',
          row: 3,
          col: 8,
        },
        5: {
          clue: '¿Qué element natural buscaban los abórigenes de Buenos Aires para hacer sus armas?',
          answer: 'PIEDRAS',
          row: 4,
          col: 6,
        },
        6: {
          clue: 'Los guaraníes llamaban a los aborígenes de Buenos Aires "querandíes" y los diaguitas los llamaban "pampas". ¿Qué nombre se daban ellos mismos?',
          answer: 'HET',
          row: 5,
          col: 6,
        },
        7: {
          clue: '¿Qué usaban para hacer sus viviendas y sus vestimentas?',
          answer: 'PIELES',
          row: 6,
          col: 7,
        },
        8: {
          clue: '¿Para hacer qué elemento de caza necesitaban las piedras?',
          answer: 'FLECHAS',
          row: 7,
          col: 6,
        },
        9: {
          clue: 'Nombre del arma de caza compuesta por tres piedras enlazadas',
          answer: 'BOLEADORAS',
          row: 8,
          col: 1,
        },
        10: {
          clue: '¿Cómo se desplazaban para ir a los diferentes lugares de sus actividades?',
          answer: 'CAMINANDO',
          row: 9,
          col: 1,
        },
        11: {
          clue: '¿Cómo se llama el animal que siempre cazaban para comer?',
          answer: 'GUANACOS',
          row: 10,
          col: 4,
        },
      },
    },
  },
  // id 10 title: "Libertadores de América"
  {
    id: 10,
    title: "Libertadores de América",
    description: "Obra Relacionada: Libertadores de América",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "LIBERTADORES",
          row: 0,
          col: 8,
        },
      },
      across: {
        1: {
          clue: "Nombre de lo que Francisco Miranda tenía preparado para lograr la libertad de América",
          answer: "PLAN",
          row: 0,
          col: 7,
        },
        2: {
          clue: "Nombre del líder de la Independencia estadounidense al cual ayuda Francisco Miranda",
          answer: "WASHINGTON",
          row: 1,
          col: 4,
        },
        3: {
          clue: "Estado que Sun Tsú recomienda lograr en combate y que consiste en equiparar las fuerzas opuestas",
          answer: "EQUILIBRIO",
          row: 2,
          col: 2,
        },
        4: {
          clue: "¿De qué nacionalidad es la revolución europea a la que Francisco Miranda contribuye a lograr?",
          answer: "FRANCESA",
          row: 3,
          col: 3,
        },
        5: {
          clue: "Sobrenombre con el cual se identifica a Francisco Miranda",
          answer: "PRECURSOR",
          row: 4,
          col: 0,
        },
        6: {
          clue: "Nombre del cacique mapuche con el cual se identifica la logia de Alvear y San Martín",
          answer: "LAUTARO",
          row: 5,
          col: 5,
        },
        7: {
          clue: "¿De qué era el 'Arte' que Sun Tsú había diseñado?",
          answer: "GUERRA",
          row: 6,
          col: 3,
        },
        8: {
          clue: "Nombre que recibió la expedición que en 1814 envía Fernando VII, primero al Río de la Plata y luego a Venezuela",
          answer: "PACIFICADORA",
          row: 7,
          col: 0,
        },
        9: {
          clue: "Apellido del otro libertador de América",
          answer: "BOLIVAR",
          row: 8,
          col: 7,
        },
        10: {
          clue: "Cantidad de invasiones del ejército realista que Martín Güemes resistió en el Norte de Salta y Jujuy",
          answer: "TRECE",
          row: 9,
          col: 7,
        },
        11: {
          clue: "Cantidad de columnas en las que San Martín dividió al Ejército de Los Andes para el cruce",
          answer: "SEIS",
          row: 10,
          col: 7,
        },
        12: {
          clue: "Paso por el cual cruzó el Gral. Las Heras para hacer creer a los realistas que era la columna principal",
          answer: "USPALLATA",
          row: 11,
          col: 7,
        },
      },
    },
  },
  // id 11 title: "Sarmiento, un Domingo en la escuela"
  {
    id: 11,
    title: "Sarmiento, un Domingo en la escuela",
    description: "Obra Relacionada: Sarmiento, un Domingo en la escuela",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "DFSARMIENTO",
          row: 0,
          col: 7,
        },
      },
      across: {
        1: {
          clue: "País del que procedían las 65 maestras contratadas por Sarmiento en 1868 para enseñar a las futuras maestras de todo el país.",
          answer: "ESTADOS",
          row: 0,
          col: 3,
        },
        2: {
          clue: "Segunda parte del nombre del país de las maestras",
          answer: "UNIDOS",
          row: 0,
          col: 11,
        },
        3: {
          clue: "Idioma en el que escribe, durante su huida a Chile en 1841, la famosa frase 'Las ideas no se matan'. Lo hace en este idioma para desafiar a los federales que odiaban todo lo que no fuera criollo.",
          answer: "FRANCES",
          row: 1,
          col: 7,
        },
        4: {
          clue: "Disciplina que, según los deseos de Sarmiento y Juana Manso, debían dominar las maestras estadounidenses para poder enseñarle a las criollas a valorizar su cuerpo.",
          answer: "GIMNASIA",
          row: 2,
          col: 2,
        },
        5: {
          clue: "Elemento que, en lugar de cuaderno, utilizaban los alumnos para escribir cuando Sarmiento era chico.",
          answer: "PIZARRAS",
          row: 3,
          col: 4,
        },
        6: {
          clue: "Prenda introducida por Sarmiento en la escuela para igualar a los alumnos y asegurar la higiene.",
          answer: "GUARDAPOLVOS",
          row: 4,
          col: 4,
        },
        7: {
          clue: "Actividad intelectual, opuesta al razonamiento, en la que se basaba la enseñanza cuando Sarmiento era chico",
          answer: "MEMORIA",
          row: 5,
          col: 5,
        },
        8: {
          clue: "Condición que, según la ley 1.420 (impulsada por Sarmiento y Juana Manso) debe cumplir la enseñanza argentina, además de ser pública y obligatoria.",
          answer: "GRATUITA",
          row: 6,
          col: 2,
        },
        9: {
          clue: "Sinónimo de pueblo educado y capacitado para decidir. Su lema era 'Educar al ...'",
          answer: "SOBERANO",
          row: 7,
          col: 4,
        },
        10: {
          clue: "Lo que actualmente reciben los alumnos y alumnas una vez evaluado el conocimiento de un tema. Cuando Sarmiento era chico la evaluación se regía según un sistema de premios y castigos.",
          answer: "NOTA",
          row: 8,
          col: 7,
        },
        11: {
          clue: "Nombre que recibían quienes estaban a cargo de la enseñanza cuando Sarmiento era chico.",
          answer: "MAESTROS",
          row: 9,
          col: 3,
        },
        12: {
          clue: "Partido político (al que pertenecía Sarmiento) cuyos miembros se dejaban crecer una pequeña barba con la intención de diferenciarse de sus opositores (los federales).",
          answer: "UNITARIO",
          row: 10,
          col: 0,
        },
      },
    },
  },
  // id 12 title: "Caminito Criollo"
  {
    id: 12,
    title: "Caminito Criollo",
    description: "Obra Relacionada: Caminito Criollo",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "CAMINITO",
          row: 0,
          col: 6,
        },
      },
      across: {
        1: {
          clue: "Medio de transporte tirado por bueyes que usaron para ir a Tucumán.",
          answer: "CARRETA",
          row: 0,
          col: 6,
        },
        2: {
          clue: "Medio de transporte de pasajeros, tirado por caballos que usaron para ir a Tucumán",
          answer: "GALERA",
          row: 1,
          col: 5,
        },
        3: {
          clue: "Lugar de destino de los diputados, donde se declara la Independencia",
          answer: "TUCUMAN",
          row: 2,
          col: 2,
        },
        4: {
          clue: "¿Qué eran Bernardito y Pepitito en la obra?",
          answer: "DIPUTADOS",
          row: 3,
          col: 5,
        },
        5: {
          clue: "¿Cómo dice la canción que viajaban los pasajeros en una galera?",
          answer: "JUNTITOS",
          row: 4,
          col: 4,
        },
        6: {
          clue: "Los viajeros se agarraban de la cola del caballo para cruzar los ¿…?",
          answer: "RIOS",
          row: 5,
          col: 5,
        },
        7: {
          clue: "¿Cómo se llaman los lugares donde los viajeros paraban a dormir y comer?",
          answer: "POSTAS",
          row: 6,
          col: 3,
        },
        8: {
          clue: "¿En qué medio de transporte viajan primero en la obra?",
          answer: "CABALLO",
          row: 7,
          col: 0,
        },
      },
    },
  },
  // id 13 title: "Empanadas para José"
  {
    id: 13,
    title: "Empanadas para José",
    description: "Obra Relacionada: Empanadas para José",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "EMPANADASJOSE",
          row: 0,
          col: 6,
        },
      },
      across: {
        1: {
          clue: "Nombre del árbol bajo el cual era acunado San Martín cuando era bebé en Yapeyú, Corrientes",
          answer: "HIGUERA",
          row: 0,
          col: 2,
        },
        2: {
          clue: "Tipos de instrumentos que se fabricaban en Yapeyú mientras fue una estancia jesuita",
          answer: "MUSICALES",
          row: 1,
          col: 6,
        },
        3: {
          clue: "Regalo de casamiento que le obsequian los granaderos a San Martín y Remedios",
          answer: "PAÑUELO",
          row: 2,
          col: 6,
        },
        4: {
          clue: "Instrumento que San Martín solía tocar con mucha habilidad",
          answer: "GUITARRA",
          row: 3,
          col: 2,
        },
        5: {
          clue: "Nombre de la nación aborigen a la cual pertenecía Rosa Guarú, la niñera de San Martín",
          answer: "GUARANI",
          row: 4,
          col: 1,
        },
        6: {
          clue: "Instrumento que Juan M. de Pueyrredón envió a San Martín en un cajoncito por correo",
          answer: "CLARINES",
          row: 5,
          col: 4,
        },
        7: {
          clue: "Elemento para acampar que Juan M. de Pueyrredón envió a San Martín",
          answer: "TIENDAS",
          row: 6,
          col: 2,
        },
        8: {
          clue: "Elemento de combate del cual Pueyrredón envió 200 unidades",
          answer: "SABLES",
          row: 7,
          col: 5,
        },
        9: {
          clue: "Elemento de abrigo del cual Pueyrredón envió 500 unidades",
          answer: "PONCHOS",
          row: 8,
          col: 0,
        },
        10: {
          clue: "Elementos que recaudó Remedios entre las damas cuyanas para ayudar a San Martín",
          answer: "JOYAS",
          row: 9,
          col: 6,
        },
        11: {
          clue: "Nombre del lugar en el que se guardaban los explosivos en el Plumerillo",
          answer: "POLVORIN",
          row: 10,
          col: 2,
        },
        12: {
          clue: "Nombre del elemento que estaba prohibido usar para entrar al polvorín.",
          answer: "ESPUELAS",
          row: 11,
          col: 5,
        },
        13: {
          clue: "Nombre del alimento que Pueyrredón envió a San Martín",
          answer: "CARNE",
          row: 12,
          col: 2,
        },
      },
    },
  },
  // id 14 title: "Habla la casita"
  {
    id: 14,
    title: "Habla la casita",
    description: "Obra Relacionada: Habla la casita",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
    crosswordData: {
      down: {
        1: {
          clue: "Nombre del crucigrama",
          answer: "HABLALACASITA",
          row: 0,
          col: 6,
        },
      },
      across: {
        1: {
          clue: "¿Qué es lo que hace la Casa Histórica en la obra?",
          answer: "HABLA",
          row: 0,
          col: 6,
        },
        2: {
          clue: "Francisca recibió la casa como regalo de …..",
          answer: "CASAMIENTO",
          row: 1,
          col: 3,
        },
        3: {
          clue: "Apellido de Francisca",
          answer: "BAZAN",
          row: 2,
          col: 6,
        },
        4: {
          clue: "General que ocupó la casa con sus soldados antes de la Batalla de Tucumán",
          answer: "BELGRANO",
          row: 3,
          col: 4,
        },
        5: {
          clue: "Cuál fue el único alimento que tenían para darles de cenar a los soldados",
          answer: "MAIZ",
          row: 4,
          col: 5,
        },
        6: {
          clue: "¿En qué se convirtió la casa de Francisca antes de la Batalla de Tucumán?",
          answer: "CUARTEL",
          row: 5,
          col: 0,
        },
        7: {
          clue: "¿Qué comida hicieron con el maíz?",
          answer: "MAZAMORRA",
          row: 6,
          col: 3,
        },
        8: {
          clue: "¿De qué color pintaron el portón de la casa para el 9 de julio de1816?",
          answer: "CELESTE",
          row: 7,
          col: 6,
        },
        9: {
          clue: "¿Qué parte de la casa pintaron de blanco?",
          answer: "PAREDES",
          row: 8,
          col: 5,
        },
        10: {
          clue: "¿Qué se celebró en la casa de Francisca durante el año 1816?",
          answer: "CONGRESO",
          row: 9,
          col: 0,
        },
        11: {
          clue: "La mezcla que usaron para revocar las paredes tenía barro, pasto y …",
          answer: "ESTIERCOL",
          row: 10,
          col: 3,
        },
        12: {
          clue: "¿Qué invento de 1869 sirvió para poder reconstruir la casa años más tarde?",
          answer: "FOTO",
          row: 11,
          col: 4,
        },
        13: {
          clue: "¿Cómo le decía la gente a la protección de vidrio que cubría el salón de la independencia?",
          answer: "QUESERA",
          row: 12,
          col: 0,
        },
      },
    },
  },
  // id 15 title: "Juntos a la mar"
  {
    id: 15,
    title: "Juntos a la mar",
    description: "Obra Relacionada: Juntos a la mar",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 16 title: "El Tesoro argentino"
  {
    id: 16,
    title: "El Tesoro argentino",
    description: "Obra Relacionada: El tesoro Argentino",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 17 title: "Chocolate para la Libertad"
  {
    id: 17,
    title: "Chocolate para la Libertad",
    description: "Obra Relacionada: Chocolate por la Libertad",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 18 title: "Manuel Belgrano"
  {
    id: 18,
    title: "Manuel Belgrano",
    description: "Obra Relacionada: Manuel Belgrano, ensayo ¡General!",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 19 title: "San Martín, un general sin Remedios"
  {
    id: 19,
    title: "San Martín, un general sin Remedios",
    description: "Obra Relacionada: San Martín, un general sin Remedios",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 20 title: "Dos tipos audaces"
  {
    id: 20,
    title: "Dos tipos audaces",
    description: "Obra Relacionada: Dos tipos audaces",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 21 title: "Celestiblanca"
  {
    id: 21,
    title: "Celestiblanca",
    description: "Obra Relacionada: Celestiblanca",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
  // id 22 title: "La gran Semana de Mayo"
  {
    id: 22,
    title: "La gran Semana de Mayo",
    description: "Obra Relacionada: La Gran Semana de Mayo",
    estado: "A jugar",
    miniatura: {
      letras: generarMiniaturaRandom(palabrasTresLetras)
    },
  },
];

export { crucigramasData };
